import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const LIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="LI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M0 0v6h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#000"
          fillRule="evenodd"
          d="M2.4 5.527s.603.375 2 .375c1.399 0 2.14-.375 2.14-.375s-1.096-.638-2.076-.638-2.065.638-2.065.638Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFD83D"
          stroke="#000"
          strokeWidth={0.4}
          d="M5.365 1.568c.354-.089.795-.142 1.146.163.34.297.394.75.38 1.08a2.67 2.67 0 0 1-.087.567l-.011.038-.003.01-.001.004v.001l-.045.14H2.32l-.057-.099.172-.1-.172.1h-.001V3.47l-.002-.004-.006-.01-.022-.04a2.29 2.29 0 0 1-.205-.591 1.235 1.235 0 0 1 .023-.587.913.913 0 0 1 .438-.53c.445-.251.847-.216 1.188-.126.16.042.325.102.453.142.137.043.247.07.342.07.095 0 .22-.029.38-.076.15-.044.337-.106.514-.15Z"
        />
        <Path
          fill="#FFD83D"
          stroke="#000"
          strokeWidth={0.4}
          d="M4.488 2.934c.852 0 1.49.11 1.92.221a4.283 4.283 0 0 1 .61.208l.035.016.009.005.003.002h.002l.156.083-.061.165-.593 1.584-.067.177-.18-.056-.001-.001-.007-.002-.03-.008a7.469 7.469 0 0 0-.523-.126 6.54 6.54 0 0 0-1.264-.139c-.464 0-.93.07-1.283.14a8.169 8.169 0 0 0-.54.125l-.03.009-.007.002h-.002l-.18.055-.065-.178-.576-1.584-.06-.164.155-.081v-.001l.003-.002a.728.728 0 0 1 .01-.005l.034-.016c.03-.013.07-.031.125-.052.11-.044.272-.1.487-.156.429-.111 1.067-.221 1.92-.221ZM4.437.962c.336 0 .536.324.536.623s-.2.622-.536.622-.536-.323-.536-.622c0-.298.2-.623.536-.623Z"
        />
        <Mask
          id="c"
          width={3}
          height={3}
          x={3.059}
          y={-1}
          fill="#000"
          maskUnits="userSpaceOnUse"
        >
          <Path fill="#fff" d="M3.059-1h3v3h-3z" />
          <Path
            fillRule="evenodd"
            d="M4.563 0h-.252l.032.461L4.06.423V.74L4.348.7l-.037.726h.252L4.526.7l.29.04V.424l-.285.04L4.563 0Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="#FFD83D"
          fillRule="evenodd"
          d="M4.563 0h-.252l.032.461L4.06.423V.74L4.348.7l-.037.726h.252L4.526.7l.29.04V.424l-.285.04L4.563 0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#000"
          d="M4.31 0v-.4h-.428l.03.428L4.31 0Zm.253 0 .4.028.029-.428h-.429V0Zm-.22.461L4.29.858l.488.066-.035-.49-.399.027ZM4.06.423l.054-.397-.454-.061v.458h.4Zm0 .317h-.4v.458l.454-.062L4.06.74ZM4.348.7l.4.02.024-.482-.479.066.055.396Zm-.037.726-.4-.02-.02.42h.42v-.4Zm.252 0v.4h.421l-.021-.42-.4.02ZM4.526.7l.056-.396-.48-.069.024.485.4-.02Zm.29.04-.057.397.456.064V.74h-.4Zm0-.316h.4V-.04l-.458.066.057.396Zm-.285.04-.4-.027-.033.494.49-.07L4.53.462ZM4.311 0v.4h.252v-.8h-.252V0Zm.032.461.4-.028-.033-.461-.4.028-.398.028.032.461.4-.028ZM4.06.423l-.054.396.284.039.054-.397.054-.396-.284-.039-.054.397Zm0 .317h.4V.423h-.8V.74h.4ZM4.348.7 4.293.304l-.289.04.055.396.054.396.29-.04L4.347.7Zm-.037.726.4.02.036-.726-.4-.02-.399-.02-.037.726.4.02Zm.252 0v-.4h-.252v.8h.252v-.4ZM4.526.7l-.4.02.038.728.399-.02.4-.021-.038-.728-.4.02Zm.29.04L4.87.345l-.29-.041-.055.396-.056.396.289.04.056-.395Zm0-.316h-.4V.74h.8V.423h-.4Zm-.285.04.057.396.284-.04-.057-.396-.057-.396-.284.04.057.396ZM4.563 0l-.399-.028-.032.464.399.027.399.028.032-.463L4.563 0Z"
          mask="url(#c)"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
